import Index from "../components/Holidays";

const Holidays = () => {
    return <Index />;
};

export default Holidays;
